import React from 'react';
import { Button, Icon, Tooltip } from 'antd';
import cn from 'classnames';
import { sortDirections } from '../constants';
import styles from './TableSortLabel.module.scss';

const TableSortLabel = ({
  children,
  rootClassName,
  direction,
  onSortClick,
}) => {
  return (
    <div className={cn(styles.root, rootClassName)}>
      {children}
      <Tooltip title="Сортировать">
        <Button shape="circle" className={styles.sortBtn} onClick={onSortClick}>
          <Icon
            className={cn(styles.icon, styles.ascIcon, {
              [styles.activeIcon]: direction === sortDirections.asc,
            })}
            type="caret-up"
          />
          <Icon
            className={cn(styles.icon, styles.descIcon, {
              [styles.activeIcon]: direction === sortDirections.desc,
            })}
            type="caret-down"
          />
        </Button>
      </Tooltip>
    </div>
  );
};

export default TableSortLabel;
